import { User } from "@moodys/cre-cpm.models.user"
import { UserType } from "@moodys/cre-cpm-client-apis.apis.services.auth"

export const isSuperadmin = (type: UserType = "company_user"): boolean => {
  return ["superadmin"].includes(type)
}

export const isCompanyAdmin = (user_type: UserType): boolean => {
  return isSuperadmin(user_type) || user_type === "company_admin"
}

export const getAvatarText = (user_reference: string): string => {
  if (!user_reference) {
    return ""
  }
  const [name, surname] = user_reference.toUpperCase().split(" ")
  return `${name[0]}${surname && surname[0] !== "<" ? surname[0] : ""}`
}

export const getUserReference = (user: User): string => {
  if (!user?.attributes.name) {
    return ""
  }
  return `${user?.attributes.name}${user?.attributes.family_name ? " " : ""}${
    user?.attributes.family_name || ""
  } <${user?.attributes.email}>`
}

export const isUserActive = (user: User): boolean => {
  return user.attributes.active
}

export const getUserColor = (userId?: number, currentUserId?: number): string => {
  return userId === currentUserId ? "#FF7A45" : "#69C0FF"
}
